import React, { useState } from "react";
import { Box, Button, Grid, TextField, Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LocationData } from "types/models/master/MasterApp";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

interface LocationProps {
  Location?: LocationData;
}

const LocationCreate: React.FC<LocationProps> = ({ Location }) => {
  const navigate = useNavigate();
  const [fileError, setFileError] = useState(false);

  const validationSchema = Yup.object({
    deviceIp: Yup.string().required('Device IP is required'),
    npCode: Yup.string().required('NP Code is required'),
    npName: Yup.string().required('NP Name is required'),
    pinCode: Yup.string().required('Pin Code is required'),
    latLng: Yup.string().required('latLng Code is required'),
    latitude: Yup.string().required('Latitude is required'),
    longitude: Yup.string().required('Longitude is required'),
    hostName: Yup.string().required('Host Name is required'),
    serviceVlanid: Yup.string().required('Service Vlan ID is required'),
    nasPortId: Yup.string().required('NAS Port ID is required'),
    voltage: Yup.string().required('Voltage is required'),
    switchConnectivity: Yup.string().required('Switch Connectivity is required'),
    switchPortNo: Yup.string().required('Switch Port Number is required'),
    switchPortConnectivity: Yup.string().required('Switch Port Connectivity is required'),
    mediaConverter: Yup.string().required('Media Converter is required'),
    location: Yup.string().required('Location is required'),
    distanceFromCo: Yup.string().required('Distance from CO is required'),
    powerBackup: Yup.string().required('Power Backup is required'),
    backupOwnership: Yup.string().required('Backup Ownership is required'),
    distanceFromLink: Yup.string().required('Distance from Link is required'),
    status: Yup.string().required('Status is required'),
  });

  const handleSubmit = (values: any) => {
    if (Location) {
      console.log('Updating Location:', values);
    } else {
      console.log('Creating Location:', values);
    }
  };

  return (
    <Box sx={{ height: "100%", width: "100%", m: 8 }}>
      <Grid sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", margin: 2 }}>
        <Formik
          initialValues={{
            deviceIp: Location ? Location.deviceIp : "",
            npCode: Location ? Location.npCode : "",
            npName: Location ? Location.npName : "",
            pinCode: Location ? Location.pinCode : "",
            latLng: Location ? Location.latLng : "",
            latitude: Location ? Location.latitude : "",
            longitude: Location ? Location.longitude : "",
            hostName: Location ? Location.hostName : "",
            serviceVlanid: Location ? Location.serviceVlanid : "",
            nasPortId: Location ? Location.nasPortId : "",
            voltage: Location ? Location.voltage : "",
            switchConnectivity: Location ? Location.switchConnectivity : "",
            switchPortNo: Location ? Location.switchPortNo : "",
            switchPortConnectivity: Location ? Location.switchPortConnectivity : "",
            mediaConverter: Location ? Location.mediaConverter : "",
            location: Location ? Location.location : "",
            rowPowerRouter:Location ? Location.rowPowerRouter : "",
            distanceFromCo: Location ? Location.distanceFromCo : "",
            powerBackup: Location ? Location.powerBackup : "",
            backupOwnership: Location ? Location.backupOwnership : "",
            distanceFromLink: Location ? Location.distanceFromLink : "",
            status: Location ? Location.status : "active",
            mac: Location ? Location.mac : "",
            makeModel: Location ? Location.makeModel : "",
            deviceName: Location ? Location.deviceName : "",
            batteryCapacity: Location ? Location.batteryCapacity : "",
            locationPowerLoad: Location ? Location.locationPowerLoad : "",
            locationAddress: Location ? Location.locationAddress : "",
            distanceFromUplink: Location ? Location.distanceFromUplink : "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid container spacing={3} mb={3}>
                                <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="Device IP"
                                    name="deviceIp"
                                    variant="outlined"
                                    error={touched.deviceIp && !!errors.deviceIp}
                                    helperText={<ErrorMessage name="deviceIp" />}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="NP Code"
                                    name="npCode"
                                    variant="outlined"
                                    error={touched.npCode && !!errors.npCode}
                                    helperText={<ErrorMessage name="npCode" />}
                                  >
                                  </Field>
                                </Grid>
                              </Grid>
                              <Grid container spacing={3} mb={3}>
                                <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="NP Name"
                                    name="npName"
                                    variant="outlined"
                                    error={touched.npName && !!errors.npName}
                                    helperText={<ErrorMessage name="npName" />}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="Pin Code"
                                    name="pinCode"
                                    variant="outlined"
                                    error={touched.pinCode && !!errors.pinCode}
                                    helperText={<ErrorMessage name="pinCode" />}
                                  >
                                  </Field>
                                </Grid>
                              </Grid>
                              <Grid container spacing={3} mb={3}>
                                <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="LatLng"
                                    name="latLng"
                                    variant="outlined"
                                    error={touched.latLng && !!errors.latLng}
                                    helperText={<ErrorMessage name="latLng" />}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Host Name"
                      name="hostName"
                      select
                      variant="outlined"
                      SelectProps={{ native: true }}
                      error={touched.hostName && !!errors.hostName}
                      helperText={<ErrorMessage name="hostName" />}
                    >
                      <option value="active">--select Hostame--</option>
                      <option value="eoc_Master">Eoc_Master</option>
                      <option value="OLT">OLT</option>
                      <option value="swiTch">SwiTch</option>
                    </Field>
                  </Grid>
                              </Grid>
                    <Grid container spacing={3} mb={3}>
                    <Grid item xs={6}>
                                  <Field
                                    as={TextField}
                                    fullWidth
                                    label="Latitude"
                                    name="latitude"
                                    variant="outlined"
                                    error={touched.latitude && !!errors.latitude}
                                    helperText={<ErrorMessage name="latitude" />}
                                  >
                                  </Field>
                                </Grid>
                    <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Longitude"
                      name="longitude"
                      variant="outlined"
                      error={touched.longitude && !!errors.longitude}
                      helperText={<ErrorMessage name="longitude" />}
                    />
                  </Grid>
                 
                </Grid>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Service Vlan ID"
                    name="serviceVlanid"
                    variant="outlined"
                    error={touched.serviceVlanid && !!errors.serviceVlanid}
                    helperText={<ErrorMessage name="serviceVlanid" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="NAS Port ID"
                    name="nasPortId"
                    variant="outlined"
                    error={touched.nasPortId && !!errors.nasPortId}
                    helperText={<ErrorMessage name="nasPortId" />}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} mb={3}>
              
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Voltage"
                    name="voltage"
                    variant="outlined"
                    error={touched.voltage && !!errors.voltage}
                    helperText={<ErrorMessage name="voltage" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Switch Connectivity"
                    name="switchConnectivity"
                    variant="outlined"
                    error={touched.switchConnectivity && !!errors.switchConnectivity}
                    helperText={<ErrorMessage name="switchConnectivity" />}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Switch Port Number"
                    name="switchPortNo"
                    variant="outlined"
                    error={touched.switchPortNo && !!errors.switchPortNo}
                    helperText={<ErrorMessage name="switchPortNo" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Switch Port Connectivity"
                    name="switchPortConnectivity"
                    variant="outlined"
                    error={touched.switchPortConnectivity && !!errors.switchPortConnectivity}
                    helperText={<ErrorMessage name="switchPortConnectivity" />}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} mb={3}>
                
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Media Converter"
                    name="mediaConverter"
                    variant="outlined"
                    error={touched.mediaConverter && !!errors.mediaConverter}
                    helperText={<ErrorMessage name="mediaConverter" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Location"
                    name="location"
                    variant="outlined"
                    error={touched.location && !!errors.location}
                    helperText={<ErrorMessage name="location" />}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} mb={3}>
              <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Row Power Router"
                    name="rowPowerRouter"
                    variant="outlined"
                    error={touched.rowPowerRouter && !!errors.rowPowerRouter}
                    helperText={<ErrorMessage name="rowPowerRouter" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Distance from CO"
                    name="distanceFromCo"
                    variant="outlined"
                    error={touched.distanceFromCo && !!errors.distanceFromCo}
                    helperText={<ErrorMessage name="distanceFromCo" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={3}>
              <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Power Backup"
                    name="powerBackup"
                    variant="outlined"
                    error={touched.powerBackup && !!errors.powerBackup}
                    helperText={<ErrorMessage name="powerBackup" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Backup Ownership"
                    name="backupOwnership"
                    variant="outlined"
                    error={touched.backupOwnership && !!errors.backupOwnership}
                    helperText={<ErrorMessage name="backupOwnership" />}
                  />
                </Grid>
              </Grid>
 <Grid container spacing={3} mb={3}>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Select Status"
                      name="status"
                      select
                      variant="outlined"
                      SelectProps={{ native: true }}
                      error={touched.status && !!errors.status}
                      helperText={<ErrorMessage name="status" />}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Field>
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="MAC"
                      name="mac"
                      variant="outlined"
                      error={touched.mac && !!errors.mac}
                      helperText={<ErrorMessage name="mac" />}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} mb={3}>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Make Model"
                  name="makeModel"
                  variant="outlined"
                  error={touched.makeModel && !!errors.makeModel}
                  helperText={<ErrorMessage name="makeModel" />}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Device Name"
                  name="deviceName"
                  variant="outlined"
                  error={touched.deviceName && !!errors.deviceName}
                  helperText={<ErrorMessage name="deviceName" />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Battery Capacity"
                  name="batteryCapacity"
                  variant="outlined"
                  error={touched.batteryCapacity && !!errors.batteryCapacity}
                  helperText={<ErrorMessage name="batteryCapacity" />}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Power Backup(hrs)"
                  name="powerBackup"
                  variant="outlined"
                  error={touched.powerBackup && !!errors.powerBackup}
                  helperText={<ErrorMessage name="powerBackup" />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Location Power Load"
                  name="locationPowerLoad"
                  variant="outlined"
                  error={touched.locationPowerLoad && !!errors.locationPowerLoad}
                  helperText={<ErrorMessage name="locationPowerLoad" />}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Location Address"
                  name="locationAddress"
                  variant="outlined"
                  error={touched.locationAddress && !!errors.locationAddress}
                  helperText={<ErrorMessage name="locationAddress" />}
                />
              </Grid>
            </Grid>
            <Grid item xs={6}>
                <Field
                  as={TextField}
                  fullWidth
                  label="Distance From Uplink"
                  name="distanceFromUplink"
                  variant="outlined"
                  error={touched.distanceFromUplink && !!errors.distanceFromUplink}
                  helperText={<ErrorMessage name="distanceFromUplink" />}
                />
              </Grid>
              <Box
                sx={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  display: "flex",
                  justifyContent: "right",
                  gap: 2,
                  paddingBottom: 2,
                  paddingTop: 2,
                  zIndex: 1000,
                  backgroundColor: "white",
                  boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate("/master/manageUser/users")}
                  sx={{ textTransform: "none", cursor: "pointer" }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "none", cursor: "pointer", right: 4 }}
                >
                  {Location ? "Update Location" : "Add Location"}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Grid>

      <Snackbar
        open={fileError}
        autoHideDuration={6000}
        onClose={() => setFileError(false)}
      >
        <Alert onClose={() => setFileError(false)} severity="error" sx={{ width: "100%" }}>
          {fileError ? "You can only upload one image." : "User added successfully!"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LocationCreate;
